import { Chip, Stack, Typography } from "@mui/material"
import Color from "color"
import uniqolor from "uniqolor"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Repeat } from "lib/@components/repeat"
import { getContrastingColor } from "lib/get-contrasting-color"

export function MacroCategoriesView({ categories = [] }) {
    return (
        <If truthy={categories.length > 0}>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                <Repeat list={categories} pass="category" item={<CategoryChip />} />
            </Stack>
            <Else>
                <Typography>No categories.</Typography>
            </Else>
        </If>
    )
}

function CategoryChip({ category }) {
    const { color } = uniqolor(category, { saturation: [65, 99], lightness: [65, 87] })
    const textColor = getContrastingColor(Color(color).mix(Color("white"), 0.5).hex())
    return <Chip label={category} size="small" sx={{ backgroundColor: `${color}80`, color: textColor }} />
}
